// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".myConfigsMaxWidth[data-v-1dafef8c]{max-width:1200px}.btn_return_width[data-v-1dafef8c]{width:200px}.downloadBOMIcon[data-v-1dafef8c]{height:40px;width:auto}i[data-v-1dafef8c]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
